

import { getToken } from "./tokenStore";
const baseApi7Url = process.env.REACT_APP_BASE_API_7_URL;


function getAuthApiUrl(urlInfo) {
  const urlMap = {
    "qa12": "REACT_APP_AUTH_API_URL_QA12",
    "qa": "REACT_APP_AUTH_API_URL",
  };

  return urlMap[urlInfo] || urlMap["qa"];
}



export async function exchangeToken(authID, urlInfo) {
  const authAPIvariable = getAuthApiUrl(urlInfo);
  const authApiUrl = process.env[authAPIvariable];

  let res = await fetch(`${authApiUrl}/ExchangeOAuth`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify({ token: authID }),
  });

  if (res.status === 200) {
    let data = await res.json();
    return data;
  } else {
    let name = "sessionout";
    window.parent.postMessage(name, "*");
    await new Promise((resolve) => setTimeout(resolve, 500));
  }
  // else throw res;
}

export async function validateToken( urlInfo) {
  const token = getToken();
  const authAPIvariable = getAuthApiUrl(urlInfo);
  const authApiUrl = process.env[authAPIvariable];

  let res = await fetch(`${authApiUrl}/ValidateToken`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify({ token }),
  });
  let data = await res.json();

  if (data.statusCode !== 200) {
    let name = "sessionout";
    window.parent.postMessage(name, "*");
    await new Promise((resolve) => setTimeout(resolve, 500));
    return false;
  }

  return true;
}
export async function refreshToken(token, refAuthID, urlInfo) {
  const authAPIvariable = getAuthApiUrl(urlInfo);
  const authApiUrl = process.env[authAPIvariable];
  const res = await fetch(`${authApiUrl}/RefreshToken`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    },
    body: JSON.stringify({ refAuthID }),
  });

  const data = await res.json();
  if (data.statusCode === 200) {
    return {
      token: data.token,
      minutesToExpire: data.minutesToExpire,
      refAuthID: data.refAuth,
    };
  }
  let name = "sessionout";
  window.parent.postMessage(name, "*");
  await new Promise((resolve) => setTimeout(resolve, 500));
  return null;
}

export async function getCorporations(urlInfo) {
  const isValidToken = await validateToken( urlInfo);
    const token = getToken();
  if (!isValidToken) return null;

  let res = await fetch(`${baseApi7Url}/corporations?IsShowAll=false`, {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    },
  });

  return res.json();
}
export async function getpreference( urlInfo) {
  const isValidToken = await validateToken(urlInfo);
    const token = getToken();
  if (!isValidToken) return null;

  let res = await fetch(`${baseApi7Url}/GetLegalNameorDbName`, {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    },
  });

  return res.json();
}

export async function getPCS(  corporationID, urlInfo) {
  const isValidToken = await validateToken(urlInfo);
    const token = getToken();
  if (!isValidToken) return null;

  let res = await fetch(`${baseApi7Url}/pcs?CorpID=${corporationID}`, {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    },
  });

  let data = await res.json();
  return data["ListInfo"];
}
